import React from 'react';
interface BonusSectionProps {
  onScrollToOffer: () => void;
}
export function BonusSection({
  onScrollToOffer
}: BonusSectionProps) {
  const bonuses = [{
    title: 'BONO 1: Proyecto Pre-Armado para Claude.ai',
    value: '$9.900',
    description: 'Todas las 33 skills combinadas en un solo set de instrucciones. Copiás, pegás, y ya tenés tu asistente completo de infoproductos configurado. Cero fricción.',
    image: 'https://cdn.magicpatterns.com/uploads/9CFhQxXrepcFa9xA4J9Pxo/Portada_de_bono_para_Claude.ai.png'
  }, {
    title: 'BONO 2: Swipe File de 50 Hooks que Convierten',
    value: '$7.900',
    description: '50 ganchos para videos y reels categorizados en 8 tipos: pregunta directa, dato impactante, controversial, antes/después, storytelling, pattern interrupt, enemigo común y resultado específico. Adaptados al nicho de infoproductos.',
    image: 'https://cdn.magicpatterns.com/uploads/n7oajyqKj9cFk9A6g6WH5u/Guia_de_marketing__Swipe_File.png'
  }, {
    title: 'BONO 3: Matriz de Diversificación Creativa (Template)',
    value: '$6.900',
    description: 'El framework de 16 deseos de Reiss cruzado con los 5 niveles de consciencia de Schwartz. Template rellenable + ejemplo completado. Usá esto con la Skill #22 y nunca más te quedés sin ideas para ads.',
    image: 'https://cdn.magicpatterns.com/uploads/hxM7QcUYEoEcWfgtSvfwVF/Matriz_de_diversificacion_creativa.png'
  }, {
    title: 'BONO 4: Checklist de Lanzamiento en 14 Días',
    value: '$4.900',
    description: 'Plan de lanzamiento día por día con checklist completa: pre-launch (día 1-7), launch (día 8-14), post-launch. Incluye tabla de métricas para completar después del lanzamiento.',
    image: 'https://cdn.magicpatterns.com/uploads/qnWnF5Qsj4i1puMZjSDuaT/Portada_para_plan_de_lanzamiento.png'
  }];
  return <section className="py-20 px-4" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-19">
            BONOS (GRATIS POR HOY)
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-20">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white/5 border border-[#00B4D8]/30 rounded-2xl overflow-hidden backdrop-blur-sm flex flex-col" data-id="element-21">
              <div className="relative cursor-pointer" onClick={onScrollToOffer} data-id="element-22">
                <div className="absolute top-4 right-4 bg-[#E74C3C] text-white font-bold py-1 px-3 rounded-full text-sm z-10 shadow-lg transform rotate-3" data-id="element-23">
                  GRATIS HOY
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-24" />
              </div>
              <div className="p-8 flex-1 flex flex-col" data-id="element-25">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 mb-4" data-id="element-27">
                  Valor: <span className="line-through" data-id="element-28">{bonus.value}</span> —{' '}
                  <span className="text-[#27AE60] font-bold" data-id="element-29">GRATIS HOY</span>
                </p>
                <p className="text-gray-300 leading-relaxed" data-id="element-30">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-20 text-center" data-id="element-31">
          <h3 className="text-3xl font-bold text-white mb-8" data-id="element-32">
            Todo lo que te llevás hoy
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/ntUnWSfY4rpG3Xr7ommpfs/Paquete_completo_Infoskills_Pro_con_bonos_(1).png" alt="Pack Completo InfoSkills Pro" className="w-full max-w-4xl mx-auto drop-shadow-2xl cursor-pointer hover:scale-[1.02] transition-transform duration-300 rounded-2xl" onClick={onScrollToOffer} data-id="element-33" />
        </div>
      </div>
    </section>;
}